import { motion, useMotionValue } from 'framer-motion';
import React, { useContext } from 'react';
import GitBtn from '../../Assets/Midia/github.svg';
import LinkedinBtn from '../../Assets/Midia/linkedin.svg';
import Bg1 from '../../Assets/Salutation/bg1Character.svg';
import Bg2 from '../../Assets/Salutation/bg2Character.svg';
import Persona from '../../Assets/Salutation/persona.svg';
import Header from "../../Components/Header";
import { DefaultContext } from '../../Contexts/DefaultContext';
import { eng, ptbr } from '../../Translate';
import '../../index.css';
import './local.css';

function Salutation() {
  const { LNG } = useContext(DefaultContext)
  const tiltStrength = 30; // ajuste isso conforme necessário
  const rotateX = useMotionValue(0);
  const rotateY = useMotionValue(0);
  const setTransition = {
    duration: 1,
    delay: 0.5,
    ease: [0, 0.91, 0.2, 1.01],
    scale: {
      type: "spring",
      damping: 10,
      stiffness: 100,
      restDelta: 0.001
    }
  }

  const handleMouseMove = (e) => {
    const xPos = (e.clientX / window.innerWidth - 0.2) * tiltStrength;
    const yPos = (e.clientY / window.innerHeight - 0.2) * tiltStrength;
    rotateX.set(yPos);
    rotateY.set(-xPos);
  };

  const openWebPage = (direct) => {
    if (direct === 'Git') window.open('https://github.com/guilhermedora', '_blank')
    else window.open('https://www.linkedin.com/in/guilhermedora/', '_blank')
  };

  return (
    <div
      id='salutation-container'
      onMouseMove={handleMouseMove}
    >
      <Header />
      <div className="section">
        <div className="letters">
          <span className="bodyTxt salut">{LNG ? ptbr.salutation.item_1 : eng.salutation.item_1}</span>
          <h1 className="titleTxt name">{LNG ? ptbr.salutation.item_2 : eng.salutation.item_2}</h1>
          <span className="bodyTxt determination-1">{LNG ? ptbr.salutation.item_3 : eng.salutation.item_3}</span>
          <span className="bodyTxt determination-2">{LNG ? ptbr.salutation.item_4 : eng.salutation.item_4}</span>
          <div className="media">
            <motion.div
              style={{ marginRight: '1.5rem' }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1.01 }}
              transition={setTransition}
              onClick={() => openWebPage("Linkedin")}
            >
              <img
                className="iconMedia"
                src={LinkedinBtn}
                alt="Imagem"
              />
            </motion.div>
            <motion.div
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1.01 }}
              transition={setTransition}
              onClick={() => openWebPage("Git")}
            >
              <img
                className="iconMedia"
                src={GitBtn}
                alt="Imagem"
              />
            </motion.div>
          </div>
        </div>
        <div className="art">
          <img
            className="background-2"
            src={Bg2}
            alt="Imagem"
          />
          <img
            className="persona"
            src={Persona}
            alt="Imagem"
          />
          <motion.div
            className="motion-background-1"
            style={{
              rotateX: rotateX,
              rotateY: rotateY,
            }}
          >
            <img
              className="background-1"
              src={Bg1}
              alt="Imagem"
            />
          </motion.div>
        </div>
      </div>
    </div >
  );
}

export default Salutation;